import { Button } from '@mui/material';
import SearchInput from 'components/SearchInputNavbar';
import BaseTable from 'components/ui/tables/BaseTable';
import useTopPanel from 'hooks/useTopPanel';
import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import EventsTable from 'components/ui/tables/EventsTable';

const SentMessages = () => {
  const { setComponent } = useTopPanel();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    setComponent(
      <div className='component-title'>{t('settings.sentMessages.title')}</div>
    );
  }, [i18n.language]);

  const [refetch, setRefetch] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className='component-list-wrapper'>
      <div className='component-list-header mb-2'>
        <div className='header-actions-container py-3 flex flex-row items-center'>
          <div className='header-actions filter-box flex items-center px-4 w-full'>
            <Button
              variant='base'
              color='primary'
              startIcon={<i className='bi bi-filter' />}
              className='!mr-2'
            >
              {t('common.button.filter')}
            </Button>
            <SearchInput inputKey='name' />
          </div>
          <div className='header-actions action-buttons-box py-3 px-4 flex gap-2 items-center justify-center'>
            <Button
              variant='base'
              color='info'
              onClick={() => {
                setRefetch(true);
              }}
              disable={`${refetch}`}
            >
              <i
                className={`bi bi-arrow-repeat${
                  refetch ? ' animate-spin' : ''
                }`}
              />
            </Button>
            {/* <Button
              variant='base'
              color='success'
              className='!mx-2'
              onClick={() => {
                navigate('/admin/settings/company/add');
              }}
            >
              <i className='bi bi-plus-circle' />
            </Button> */}
            <Button
              variant='base'
              color='default'
              onClick={() => setOpen(true)}
            >
              <i className='bi bi-gear' />
            </Button>
          </div>
        </div>
      </div>

      <div className='component-table-wrapper h-[calc(100vh-180px)]'>
        <EventsTable
          emitRefetch={{ refetch, setRefetch }}
          dataPath='admin/sms/index'
          emitTableColumns={{ open, setOpen }}
          tableName='companies'
          headCells={[
            { code: 'lead', label: t('common.table.sentLead') },
            { code: 'custom', label: t('common.table.customReceiver') },
            { code: 'phone', label: t('common.table.receiver') },
            { code: 'staff', label: t('common.table.sender') },
            { code: 'status', label: t('common.table.status') },
            { code: 'text', label: t('common.table.sms') },
          ]}
          columns={[
            { code: 'lead', type: 'nested', childStr: 'name' },
            { code: 'custom', type: 'nested', childStr: 'name' },
            { code: 'phone' },
            { code: 'staff', type: 'nested', childStr: 'name' },
            { code: 'status' },
            { code: 'text' },
          ]}
          //   actionEdit={true}
          noActions
        />
      </div>
    </div>
  );
};

export default memo(SentMessages);
